import React, { useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import toSeoUrl from "@functions/toSeoUrl";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import PlusIcon from "@components/Icons/PlusIcon";
import Button from "@components/Ui/Button";
import Loader from "@components/Ui/Loader";
import Drawer from "@components/V3/Drawer";
import Venues from "@components/V3/VenueFinder/venues";

import "./style.scss";

const VenueFinder = ({ handleVenueClick }) => {
    const location = useLocation();
    const { cinemas, cinemasLoading } = useContext(ApplicationContext);
    const { drawerState, openDrawer, closeDrawer } = useContext(AuthContext);

    const venueList = useMemo(() => {
        return Array.from(
            new Map(
                cinemas
                    .map(v => v?.name?.trim())
                    .filter(Boolean)
                    .map(name => [name.toLowerCase(), { label: name, value: name }])
            ).values()
        );
    }, [cinemas]);

    const urlVenueSlug = new URLSearchParams(location.search).get("venue_name");

    const displayName = urlVenueSlug
        ? (venueList.find(item => toSeoUrl(item.value) === urlVenueSlug)?.label ?? null)
        : null;

    const selectedVenueOption = venueList.find(
        item => toSeoUrl(item.value) === urlVenueSlug
    )?.value ?? null;

    return (
        <div className="venues-finder">
            <Button
                additionalClasses="venue-finder__button"
                onClick={() => openDrawer("venuesDrawer")}
            >
                {displayName ?? "Find a cinema"} <PlusIcon className="venue-finder__icon" />
            </Button>
            <Drawer
                isOpen={drawerState.venuesDrawer}
                onClose={() => closeDrawer("venuesDrawer")}
                closeButtonAlignment="right"
                aria-label="Select your local cinema"
                role="dialog"
            >
                {cinemasLoading ? (
                    <Loader isLoading />
                ) : (
                    <>
                        <Venues
                            handleVenueClick={handleVenueClick}
                            selectedVenue={selectedVenueOption}
                            venueList={venueList}
                        />
                        <Button
                            additionalClasses="button button__primary"
                            onClick={() => closeDrawer("venuesDrawer")}
                        >
                            Save and browse
                        </Button>
                    </>
                )}
            </Drawer>
        </div>
    );
};

export default VenueFinder;
